import { type API, type TRequestsHandler } from '~/utils/requestsProcessor/types';

export class UserImpl {
  constructor(private readonly makeRequest: TRequestsHandler) {}

  /** GET /v1/user */
  public getV1User(query: { address: string }) {
    return this.makeRequest<API.V1UserRequestBody | null>(`v1/user`, { method: 'GET', query });
  }

  /** POST /v1/user */
  public postV1User(body: API.CreateUserBody) {
    return this.makeRequest<API.CreateUserResponse>(`v1/user`, { method: 'POST', body });
  }

  /** PATCH /v1/user */
  public patchV1User(body: API.UpdateUserBody) {
    return this.makeRequest<API.UpdateUserResponse | null>(`v1/user`, { method: 'PATCH', body });
  }

  /** GET /user/subscribers */
  public getUserSubscribers(query: { address: string }) {
    return this.makeRequest<{ levels: number[]; levelsToken: number[]; subscribers: number[]; earned: number[] }>(
      `user/subscribers`,
      { method: 'GET', query }
    );
  }

  /** GET /v1/user/referral-program/rewards */
  public getV1UserReferralProgramRewards(query: { address: string }) {
    return this.makeRequest<API.ReferralRewardsByUserResponseV1>(`v1/user/referral-program/rewards`, {
      method: 'GET',
      query
    });
  }

  /** GET /user/exists */
  public getUserExists(query: { id: number }) {
    return this.makeRequest<{ id: number } | null>(`user/exists`, { method: 'GET', query });
  }

  /** GET /v1/user/referral-status */
  public getV1UserReferralStatus(query: { address: string }) {
    return this.makeRequest<{ isReferralMember: boolean }>(`v1/user/referral-status`, { method: 'GET', query });
  }

  /** GET /user/{userId} */
  public getUserByUserId(userId: string) {
    return this.makeRequest<API.UpdatedUser | undefined>(`user/${encodeURIComponent(String(userId))}`, {
      method: 'GET'
    });
  }

  /** GET /v1/user/avatars */
  public getV1UserAvatars() {
    return this.makeRequest<API.GetUserAvatarsResponse>(`v1/user/avatars`, {
      method: 'GET'
    });
  }

  /** GET /user/users-stats */
  public getUserUsersStats(query: { from: string; until: string }) {
    return this.makeRequest<API.UserStatsResponse>(`user/users-stats`, {
      method: 'GET',
      query
    });
  }
}
